
import Vue from 'vue'
import BudgetSheet from "../../components/BudgetSheet";
import GeneralScopeofWork from "../../components/GeneralScopeofWorkSheet"
import {$http} from "../../axios_api/http-common"
export default Vue.extend({
    components:{
        "general-scope-Work":GeneralScopeofWork,
        "budget-sheet": BudgetSheet,
    },
    data(){
        return {
            exchangeRate:305,
            ratio:0.6,
            copiedRow:[] as Array<any>
        }
    },
    props:{
        activities:{
            default:()=>[]
        },
        rows:{
            default:()=>[]
        },
        selectedOperationUnitName:{
            default:""
        },
        fundingtranche:{
            default:""
        },
        budgetyear:{
            default:""
        },
        operationUnitId:{
            default:""
        },
        projectId:{
            default:""
        }
    },
    computed:{
        columns(){
            let columnsToReturn = []
            //compute subcom recommendation
            let subComBudget = {budgetLines:[] as Array<any>};
            let subComCompletionValues = {budgetLines:[] as Array<any>}
            let subComNairaValue = {budgetLines:[] as Array<any>}
            let subComDollarValue = {budgetLines:[] as Array<any>};
            
            (this.activities as Array<any>).forEach((a:any) => {
                if(a.budget){
                    a.budget.budgetLines.forEach((b:any) => {
                        let existingBudgetLineIndex = subComBudget.budgetLines.findIndex((sbl:any)=>sbl.lineItemId==b.lineItemId)
                        if(existingBudgetLineIndex>-1){
                            subComBudget.budgetLines[existingBudgetLineIndex].lineValue += b.lineValue
                        }
                        else  subComBudget.budgetLines.push(b)
                    });
                }
            })

            if(this.copiedRow.length>0){
                 for(let i=0;i<this.copiedRow.length;i++){
                     if( subComBudget.budgetLines.length>i){
                         subComBudget.budgetLines[i].lineValue = this.copiedRow[i].replace(',','')
                     }
                 }
            }
            
            
            subComCompletionValues.budgetLines = subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId}))
            subComNairaValue.budgetLines = subComBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*this.ratio*this.exchangeRate),lineItemId:b.lineItemId}))
            subComDollarValue.budgetLines = subComBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*(1-this.ratio)),lineItemId:b.lineItemId}))

            //handle current year budget proposal values
            let currentYearCompletionValues = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId})) }
            let currentYearBudget = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId})) }
            let currentYearNairaValue = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId}))}
            let currentYearDollarValue = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId}))}

            let previousYearQuarterFourCompletionValues = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId})) }
            let previousYearQuarterFourBudget = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId})) }
            let previousYearQuarterFourNairaValue = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId}))}
            let previousYearQuarterFourDollarValue = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId}))}

            let previousYearQuarterTwoCompletionValues = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId})) }
            let previousYearQuarterTwoBudget = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId})) }
            let previousYearQuarterTwoNairaValue = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId}))}
            let previousYearQuarterTwoDollarValue = {budgetLines: subComBudget.budgetLines.map((b:any) => ({lineValue:0,lineItemId:b.lineItemId}))}
            
            // columnsToReturn.push({id:'1',hasHeader:true,header:"2019 Q2",headerSpan:4,name:"Completion %",budget:previousYearQuarterTwoCompletionValues,editable:true})
            // columnsToReturn.push({id:'2',skipHeader:true,name:"SN'000", budget:previousYearQuarterTwoNairaValue})
            // columnsToReturn.push({id:'3',skipHeader:true,name:"$ '000",budget:previousYearQuarterTwoDollarValue})
            // columnsToReturn.push({id:'4',skipHeader:true,name:"F($)'000",budget:previousYearQuarterTwoBudget,editable:true})
            
            // columnsToReturn.push({id:'5',hasHeader:true,header:"2019 Q4",headerSpan:4,name:"Completion %",budget:previousYearQuarterFourCompletionValues,editable:true})
            // columnsToReturn.push({id:'6',skipHeader:true,name:"SN'000", budget:previousYearQuarterFourNairaValue})
            // columnsToReturn.push({id:'7',skipHeader:true,name:"$ '000",budget:previousYearQuarterFourDollarValue})
            // columnsToReturn.push({id:'8',skipHeader:true,name:"F($)'000",budget:previousYearQuarterFourBudget,editable:true})
            
            // columnsToReturn.push({id:'9',hasHeader:true,header:"2020 Budget Year",headerSpan:4,name:"Completion %",budget:currentYearCompletionValues,editable:true})
            // columnsToReturn.push({id:'10',skipHeader:true,name:"SN'000", budget:currentYearNairaValue})
            // columnsToReturn.push({id:'11',skipHeader:true,name:"$ '000",budget:currentYearDollarValue})
            // columnsToReturn.push({id:'12',skipHeader:true,name:"F($)'000",budget:currentYearBudget,editable:true})

            // columnsToReturn.push({id:'13',hasHeader:true,header:"SUB-COM Recommendation",headerSpan:4,name:"Completion %",budget:subComCompletionValues,editable:true})
            // columnsToReturn.push({id:'14',skipHeader:true,name:"SN'000", budget:subComNairaValue})
            columnsToReturn.push({id:'14',hasHeader:true,header:"SUB-COM Recommendation",headerSpan:4,name:"SN'000", budget:subComNairaValue})
            columnsToReturn.push({id:'15',skipHeader:true,name:"$ '000",budget:subComDollarValue})
            columnsToReturn.push({id:'16',skipHeader:true,name:"F($)'000",budget:subComBudget})
            return columnsToReturn
        },
    },
    methods:{
        pasteExcel(){
            $http.post("projects/operationunitkpi/print",{projectId:this.projectId,operationUnitId:this.operationUnitId})
            this.copiedRow = []
            navigator.clipboard.readText()
            .then(text => {
                var rows = text.split("\n");
                for(let i=0;i<rows.length;i++){
                    if(rows[i]=='-'||rows[i]=='')this.copiedRow.push('0') 
                    else this.copiedRow.unshift(rows[i])
                }
            })
            .catch(err => {
                window.console.error('Failed to read clipboard contents: ', err);
            });
        },
        onLineValueChanged(data:any){
           
            
        },
        newTab() {
            let divToPrint = this.$refs.projtable as any
            const blankWindow = window.open('') as any;
            blankWindow.document.write(divToPrint.outerHTML);
            blankWindow.open()
        },
        printSheet(){
            const printDiv = this.$refs.projtable as any;
            const newWindow = window.open('') as any;
            newWindow.document.write(printDiv.outerHTML);
            newWindow.print();
            newWindow.close();
            /*
            let filename = ""
            var downloadLink;
            var dataType = 'application/vnd.ms-excel'
            var tableSelect = this.$refs.projtable as any;
            var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20')

            filename = '_excel_data.xls'

            downloadLink = document.createElement('a')
            document.body.appendChild(downloadLink)

            if (navigator.msSaveOrOpenBlob) {
                var blob = new Blob(['\ufeff', tableHTML], {
                    type: dataType
                })
                navigator.msSaveOrOpenBlob(blob, filename)
            } else {
                downloadLink.href = 'data:' + dataType + ', ' + tableHTML
                downloadLink.download = filename
                downloadLink.click()
            }
            */
        }
    }
})
